import { ROUTES } from '@/constants';
import { ax } from '@/utils';
import Swal from "sweetalert2";

const state = {
    brands: [],
    marketplaces: []
};

const getters = {
    brands: state => state.brands,
    marketplaces: state => state.marketplaces
};

/**********				actions				**********/
const actions = {

    /* Brands */

    createBrand(_, brand) {
        return ax
            .post(ROUTES.CREATE_BRAND(), {brand})
            .then( res => {
                if (res.body.success == true){
                    Swal.fire({
                        icon: 'success',
                        text: "Item successfully created"
                    })

                }
            })
            .catch(error => {
                return Promise.reject(error.config)
            });
    },
    updateBrand(_, brand) {
        return ax
            .patch(ROUTES.CREATE_BRAND(), {brand})
            .then((res) => {
                if (res.body.success == true) {
                    Swal.fire({
                        icon: 'success',
                        text: "Item successfully updated"
                    })
                }
            })
            .catch(error => {
                return Promise.reject(error.config)
            })
    },
    getBrands({ commit }) {
        return ax
            .get(ROUTES.GET_BRANDS())
            .then(res => {
                commit('STORE_BRANDS', res.data.brands);
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
    getBrandProducts(_, brand) {
        return ax
            .post(ROUTES.GET_BRAND_PRODUCTS(), {brand})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
    getCollaboratorsProducts(_, brand) {
        return ax
            .post(ROUTES.GET_COLLABORATOR_PRODUCTS(), {brand})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
    deleteBrand({ commit }, id){
        return ax
            .post(ROUTES.DELETE_BRAND(), {id})
            .then(() => {
                commit('REMOVE_DELETED_BRAND', id)
            })
            .catch(error => {
                return Promise.reject(error.config)
            });
    },

    /* Outdated */

    getOutdated(){
        return ax
            .get(ROUTES.GET_OUTDATED())
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    /* Marketplace */

    createMarketplace(_, marketplace){
        return ax
            .post(ROUTES.CREATE_MARKETPLACES(), {marketplace})
            .then( res => {
                if (res.body.success == true){
                    Swal.fire({
                        icon: 'success',
                        text: "Item successfully created"
                    })

                }
            })
            .catch(error => {
                return Promise.reject(error.config)
            });
    },
    updateMarketplace(_, marketplace){
        return ax
            .patch(ROUTES.CREATE_MARKETPLACES(), {marketplace})
            .then((res) => {
                if (res.body.success == true) {
                    Swal.fire({
                        icon: 'success',
                        text: "Item successfully updated"
                    })
                }
            })
            .catch(error => {
                return Promise.reject(error.config)
            });
    },
    getMarketplaces({ commit }) {
        return ax
            .get(ROUTES.GET_MARKETPLACES())
            .then(res => {
                commit('STORE_MARKETPLACES', res.data.marketplace);
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
    getMarketplaceProducts(_, marketplace) {
        return ax
            .post(ROUTES.GET_MARKETPLACE_PRODUCTS(), {marketplace: marketplace._id})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
    deleteMarketplace({ commit }, id){
        return ax
            .post(ROUTES.DELETE_MARKETPLACE(), {id})
            .then(() => {
                commit('REMOVE_DELETED_MARKETPLACES', id)
            })
            .catch(error => {
                return Promise.reject(error.config)
            });
    }
};

/**********				mutations				**********/
const mutations = {
    STORE_BRANDS(state, brands) {
        state.brands = brands
    },
    REMOVE_DELETED_BRAND(state, id){
        state.brands = state.brands.filter(e => e._id != id);
    },
    STORE_MARKETPLACES(state, marketplaces) {
        state.marketplaces = marketplaces
    },
    REMOVE_DELETED_MARKETPLACES(state, id){
        state.marketplaces = state.marketplaces.filter(e => e._id != id)
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
